<template>
  <div>
    <div class="row" style="padding: 1%;">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="col-lg-12">
        <h4
          class="info-text"
        >Bahagian E</h4>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-9">
                Catatan COO
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-11" style="margin-top: 3%">
            <base-input @change="catatan()" label="nama" v-model="namacoo">
            </base-input>
            <base-input label="catatan">
                <textarea class="keterangan" @change="catatan()" v-model="catatancoo"></textarea>
            </base-input>
            <base-input label="tarikh">
                <el-date-picker @change="catatan()" v-model="tarikhcoo" type="date"></el-date-picker>
            </base-input>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-9">
                Catatan CEO
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-11" style="margin-top: 3%">
            <base-input @change="catatan()" label="nama" v-model="namaceo">
            </base-input>
            <base-input label="catatan">
                <textarea class="keterangan" @change="catatan()" v-model="catatanceo"></textarea>
            </base-input>
            <base-input label="tarikh">
                <el-date-picker @change="catatan()" v-model="tarikhceo" type="date"></el-date-picker>
            </base-input>
          </div>
        </div>

        
        
        <div class="row justify-content-center">
          <div class="col-md-11" style="margin-top: 3%">
            <el-radio-group v-model="kesditutup" @change="clickq()">
              <el-radio label="Kes Ditutup" value="0"></el-radio>
              <el-radio label="Tindakan Lanjut" value="1"></el-radio>
            </el-radio-group>
            <!-- <base-checkbox class="mb-3" @change="clickq()" v-model="kesditutup" >Kes Ditutup</base-checkbox>
            <base-checkbox class="mb-3" @change="clickq()" v-model="tindakanlanjut">Tindakan Lanjut</base-checkbox> -->
          </div>
        </div>

        <div class="row justify-content-center">
            <base-button @click="hantar()" :disabled="dis">Submit</base-button>
            <div class="d-flex justify-content-center spinner" v-if="load">
              <circle-8></circle-8>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker, Radio, RadioGroup } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";


export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    Loading,
    Circle8
  },
  data() {
    return {
    isLoading: false,
    load: false,
    dis: false,
    check: false,
    check2: false,
    kesditutup: "",
    tindakanlanjut: [],
    namaceo: "",
    catatanceo: "",
    tarikhceo: "",
    namacoo: "",
    catatancoo: "",
    tarikhcoo: "",
      quantity: "",
      assetName: "",
      assetNo: "",
      tindakanPencegahan: "",
      capitalizedDate: "",
      costCentre: "",
      condition: "",
      location: "",
      langkahKawalan: "",
      tarikSiap: "",
      value1: "",
      tableDetails: [],
      investigator: [],
      // {
      //   nokawalankes: "",
      //   name: "",
      //   nostaf: "",
      //   servicearea: ""
      // },
      maklumat: [],
      indate: "",
      intime: "",
      inlocationdetail: "",
      weather: "",
      surr: "",
      propdamage: "",
      injury: "",
      insummary: "",
        // inimage: "",
        // imgdesc: "",
      punca: {
        man: "",
        machine: "",
        material: "",
        method: ""
      },
      investigation: [],
      pencegahan:[],
      selects: {
        cause: [],
        class: [],
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ],
        kawalan: [],
        location: [
          { value: "HQ", label: "HQ" },
          { value: "Off HQ", label: "Off HQ" }
        ],
        costCentre: [
          { value: "Cost 1", label: "Cost 1" },
          { value: "Cost 2", label: "Cost 2" }
        ]
      },
      tableETD: [{}],
      model: {
        file: null
      },
      sendDetails: [],
      img: [],
      instid: "",
      tarikha: "",
      tarikhb: "",
      complete: 0,
      furtheraction: 0,
      removeinvestigator: [],
      deleteimage: [],
      intimestamp: "",
      keteranganimage:[]
    };
  },
  mounted(){
    this.getpvstepforupdate();
    this.panggil();
    this.$root.$on("investigatordetail", investigator => {
      console.log(investigator);
      (this.investigator = investigator);

    });
    this.fourthstep();
    this.fifthstep();
    this.investigationdata();
    this.imagedata();
    this.sixthstep();
    this.removeid();
    this.deleteinvestigator();
    
  },
  created(){
    
  },
  methods: {
    gete(){
      console.log(this.instid)
      this.$http.get(":9994/api/v1/incident/catatan/" + this.instid)
        .then(res=>{
          if (!res.error){
            let response = res.message
            console.log(response)

            for(var i=0; i<response.length; i++){
              this.namaceo = response[i].NameCEO
              this.catatanceo = response[i].NoteCEO
              this.tarikhceo = response[i].DateCEO

              this.namacoo = response[i].NameCOO
              this.catatancoo = response[i].NoteCOO
              this.tarikhcoo = response[i].DateCOO
              if(response[i].Complete === "1"){
                this.kesditutup = "Kes Ditutup"
              }
              if(response[i].FurtherAction === "1"){
                this.kesditutup = "Tindakan Lanjut"
              }
            }
          }
        })
    },
    deleteimage2(){
      this.$root.$on("deleteimage", deleteimage =>{
        console.log(deleteimage);
        (this.deleteimage = deleteimage)
      })
    },
    deleteinvestigator(){
      this.$root.$on("deleteinvestigator", deleteinvestigator =>{
        console.log(deleteinvestigator);
        (this.removeinvestigator = deleteinvestigator)
      })
    },
    removeid(){
      this.$root.$on("remove", removeinstid => {
        console.log(removeinstid);
        (this.removeid = removeinstid);

      });
    },
    clickq(){
      console.log(this.kesditutup)
      // if(this.kesditutup === "Kes Ditutup"){
      //   this.complete = 0
      //   this.furtheraction = ""
      //   console.log(this.complete)
      // } else {
      //   this.complete = ""
      //   this.furtheraction = 0
      // }
    },
      catatan(){
          console.log(this.namaceo)
          console.log(this.catatanceo)
          console.log(this.tarikhceo)

          console.log(this.namacoo)
          console.log(this.catatancoo)
          console.log(this.tarikhcoo)

          let tarikh = moment(this.tarikhceo)
          let tarikhcoo = moment(this.tarikhcoo)
          this.tarikha = tarikh.format('YYYY-MM-DD')
          this.tarikhb = tarikhcoo.format('YYYY-MM-DD')
    //   let send = {
    //     namaceo: this.nameceo,
    //     catatanceo: this.catatanceo,
    //     tarikhceo: tt,
    //     namacoo: this.namecoo,
    //     catatancoo: this.catatancoo,
    //     tarikhcoo: this.tarikhcoo
    //   }


    //   this.sendDetails.push(send)

      // this.selects.kawalan
    //   for(var i=0; i<this.selects.kawalan.length; i++){
    //     if(this.langkahKawalan === this.selects.kawalan[i].value){
    //       this.langkahKawalan = this.selects.kawalan[i].label
    //     }
    //   }
    //   let display = {
    //       langkahKawalan: this.langkahKawalan,
    //       tindakanPencegahan: this.tindakanPencegahan,
    //       tarikSiap: tt
    //     }

    //   this.tableDetails.push(display)

     
      
    //   this.langkahKawalan = ""
    //   this.tindakanPencegahan = ""
    //   this.tarikSiap = ""
      },
    getpvstepforupdate(){
      this.$root.$on("instid", instid =>{
        this.instid = instid
        this.getdata();
        this.gete();
        this.deleteimage2();
        this.updateketerangan();
      })
    },
    updateketerangan(){
      this.$root.$on("updateimageketerangan", pic =>{
        this.keteranganimage = pic
        console.log(this.keteranganimage)
      })
    },
    getdata(){
      this.$http.get(":9994/api/v1/incident/pvstep/" + this.instid)
        .then(res=>{
          if(!res.error){
            let response = res.message
            for(var i=0; i<response.length; i++){
              let stepname = ""
              if(response[i].PvStepTypeId = this.selects.kawalan[i].value){
                stepname = this.selects.kawalan[i].label
              }
              let data = {
                langkahKawalan: stepname,
                tindakanPencegahan: response[i].StepDetail,
                tarikSiap: response[i].DateExecComp
              }
              this.tableDetails.push(data)
            }
          }
        })
    },
    panggil(){
      this.getpvstep();
    },
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    getpvstep(){
      this.$http.get(":9994/api/v1/incident/pvstep")
        .then(res =>{
          if (!res.error){
            let response = res.message
            console.log(response)
            for(var i=0; i<response.length; i++){
              let data = {
                value: response[i].PvStepTypeId,
                label: response[i].PvStepName
              }

              this.selects.kawalan.push(data)
            }
            
          }
        })
    },
    investigationdata(){
      this.$root.$on("investigatordata", investigatordata =>{
        console.log(investigatordata)
        this.intimestamp = investigatordata.intimestamp
        // this.indate = investigatordata.indate
        // this.intime = investigatordata.intime
        this.inlocationdetail = investigatordata.inlocationdetail
        this.weather = investigatordata.weather
        this.surr = investigatordata.surr
        this.injury = investigatordata.injury
        this.propdamage = investigatordata.propdamage
        this.insummary = investigatordata.insummary
      })
    },
    imagedata(){
      this.$root.$on("imagedata", images =>{
        console.log(images)
        this.img = images
        console.log(this.img)
        // this.img = img
        // this.img = images
        // let imagedesc = ""
        // console.log(imagedata)
        // for(var i=0; i<images.length; i++){
        // //   // convert to base64 
        //   const reader = new FileReader()

        //   reader.onload = (event) => {
        //   images[i].imagefile = event.target.result
        //   console.log(images[i].imagefile)
        //       // rebuild cropperjs with the updated source
        //   // this.$refs.cropper.replace(event.target.result)
        //   }
        //   // reader.readAsDataURL(file)
        //   // console.log(reader.readAsDataURL(imagedata[i].imagefile))
        //   // console.log(imagedata[i].imagefile.toString())
        //   // imagedesc= imagedata[i].imagedata

        //   let imk = {
        //     imagefile: images[i].imagefile,
        //     imagedesc: images[i].imagedesc
        //   }
        
        //   this.img.push(imk)
        // }

          
        // console.log(this.img)
        })
    },
    handleDelete(index, row){
      this.tableDetails.splice(index, 1);
      
    },
    fourthstep(){
      this.$root.$on('fourthstep',data =>{
        console.log(data)
        this.maklumat = data

        // this.arrangeFourStep()
      })
    },
    sixthstep(){
      this.$root.$on("action", action =>{
        this.sendDetails = action
        console.log(this.sendDetails)
      })
    },
    arrangeFourStep(){
      // let cause = []
      // let classname = []
      // this.$http.get(":9994/api/v1/incident/classname")
      //   .then(res=>{
      //     if (!res.error){
      //       let response = res.message

      //       for(var i=0; i<response.length; i++){
      //         let data = {
      //           label: response[i].AcClassName,
      //           value: response[i].AcClassId
      //         }
      //         classname.push(data)
      //       }
      //     }
      //   });

      // this.$http.get(":9994/api/v1/incident/causename")
      //   .then(res=>{
      //     if (!res.error){
      //       let response = res.message

      //       for(var i=0; i<response.length; i++){
      //         let data = {
      //           label: response[i].AcCauseName,
      //           value: response[i].AcCauseId
      //         }
      //         cause.push(data)
      //       }
      //     }
      //   });

      // for(var i=0; i<this.maklumat.length; i++){
      //   let accausename = ""
      //   let acclassname = ""
      //   for(var j=0; j<cause.length; j++){
      //     // convert accausename to id
      //     if( cause[j].AcCauseName === this.maklumat[i].accausename){
      //       let accausename = cause[j].AcCauseId
      //     }
      //   }
      //   for(var j=0; j<classname.length; j++){
      //     // convert acclassname to id
      //     if( classname[j].AcCauseName === this.maklumat[i].accausename){
      //       let acclassname = classname[j].AcClassId
      //     }
      //   }

      //   let data = {
      //     accausename: accausename,
      //     acclassname: acclassname,
      //     age: this.maklumat[i].age,
      //     homeaddr: this.maklumat[i].homeaddr,
      //     incidentid: this.maklumat[i].incidentid,
      //     intimestamp: this.maklumat[i].intimestamp,
      //     nooflti: this.maklumat[i].nooflti,
      //     noofmc: this.maklumat[i].noofmc,
      //     startdate: this.maklumat[i].startdate,
      //     supervisor: this.maklumat[i].supervisor,
      //     telno: this.maklumat[i].telno,
      //     vehpuspa: this.maklumat[i].vehpuspa,
      //     vehregno: this.maklumat[i].vehregno,
      //     vehrtax: this.maklumat[i].vehrtax,
      //     vehtype: this.maklumat[i].vehtype,
      //     vicname: this.maklumat[i].vicname,
      //     workarea: this.maklumat[i].workarea,
      //     workscope: this.maklumat[i].workscope
      //   }

      //   this.investigation.push(data)
        
        
      // }
    },
    fifthstep(){
      this.$root.$on("fifthpage", fifth =>{
        console.log(fifth)
        this.punca.man = fifth.man
        this.punca.machine = fifth.machine
        this.punca.material = fifth.material
        this.punca.method = fifth.method
      })
    },
    submit(){
      console.log(this.tarikSiap)
      let tarikh = moment(this.tarikSiap)
      let tt = tarikh.format('YYYY-MM-DD')
      let send = {
        langkahKawalan: parseInt(this.langkahKawalan),
        tindakanPencegahan: this.tindakanPencegahan,
        tarikSiap: tt
      }
      this.sendDetails.push(send)

      // this.selects.kawalan
      for(var i=0; i<this.selects.kawalan.length; i++){
        if(this.langkahKawalan === this.selects.kawalan[i].value){
          this.langkahKawalan = this.selects.kawalan[i].label
        }
      }
      let display = {
          langkahKawalan: this.langkahKawalan,
          tindakanPencegahan: this.tindakanPencegahan,
          tarikSiap: tt
        }

      this.tableDetails.push(display)

     
      
      this.langkahKawalan = ""
      this.tindakanPencegahan = ""
      this.tarikSiap = ""
    },
    hantar(){
      this.load = true;
      this.isLoading = true;
      console.log(this.keteranganimage)
      console.log(this.investigator) // dah ok
      console.log(this.maklumat)
      console.log(this.punca.man)
      console.log(this.punca.machine)
      console.log(this.punca.material)
      console.log(this.punca.method)
      console.log(this.sendDetails)
      console.log(this.removeid)
      console.log(this.deleteimage)

      let ceod = this.tarikha
      let cood = this.tarikhb
      if(ceod == "Invalid date"){
        ceod = ""
      }
      if(cood == "Invalid date"){
        cood = ""
      }
      // let investigation2 = {}
      
      // if(this.complete === ""){
      let investigation2 = {
        intimestamp: this.intimestamp,
        inlocationdetail: this.inlocationdetail,
        weather: this.weather,
        surr: this.surr,
        injury: this.injury,
        propdamage: this.propdamage,
        insummary: this.insummary,
        man: this.punca.man,
        machine: this.punca.machine,
        material: this.punca.material,
        method: this.punca.method,
        namaceo: this.namaceo,
        catatanceo: this.catatanceo,
        tarikhceo: ceod,
        namacoo: this.namacoo,
        catatancoo: this.catatancoo,
        tarikhcoo: cood,
        complete: this.kesditutup,
        // furtheraction: this.furtheraction
      }

      let remove = []
      for(var i=0; i<this.removeid.length; i++){
        let r = parseInt(this.removeid[i])
        remove.push(r)
      }
      
      // console.log(this.indate)
      // console.log(this.intime) 
      console.log(this.intimestamp)
      console.log(this.inlocationdetail)
      console.log(this.weather)
      console.log(this.surr)
      console.log(this.injury)
      console.log(this.propdamage)
      console.log(this.insummary)

      console.log(this.img)

      let data = {
        instid: this.instid,
        investigator : this.investigator,
        investigation : this.maklumat,
        investigation2 : [investigation2],
        // indate: this.indate,
        // intime: this.intime,
        // inlocationdetail: this.inlocationdetail,
        // weather: this.weather,
        // surr: this.surr,
        // injury: this.injury,
        // propdamage: this.propdamage,
        // insummary: this.insummary,
        image: this.img,
        // man : this.punca.man,
        // machine : this.punca.machine,
        // material: this.punca.material,
        // method : this.punca.method,
        action : this.sendDetails,
        removeid: remove,
        removeinvestigator: this.removeinvestigator,
        gambar: this.deleteimage, 
        keteranganimage: this.keteranganimage
      }

      console.log(data)

      // hantaq backend
      this.$http.put(":9994/api/v1/incident/updateinvestigation/" + this.instid , data)
        .then(res=>{
          if(!res.error){
            this.load = false
            this.isLoading = false
             swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            }).then(okay => {
            if (okay) {
              // window.location.href = "URL";
              console.log("ok")
              this.$router.go()

            }
            });
            // this.$router.go()
          } else{
            this.load = false
            this.isLoading = false
            swal({
              title: "Data Error!",
              // text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
          }
        })
      
      // delete image

      // let d =
      // {
      //   gambar: this.deleteimage
      // }
      // let f = []
      // f.push(d)
      // console.log(f)
      
      // this.$http.post(":9994/api/v1/incident/image/" + this.instid, d)
      //   .then(res=>{
      //     if(!res.error){
      //       let response = res.message
      //       console.log(response)
      //     }
      //   })


    }
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
